module.exports = __webpack_public_path__ + "img/index-hero-image.abf7a6d2.png";